import React,{ useEffect, useLayoutEffect, useRef, useState } from 'react'
import NavBarLeft from '../../ReusableComp/NavBarLeft'
import NavigationBar from '../../ReusableComp/NavigationBar';
import { Container } from 'react-bootstrap';
import {Stack} from 'react-bootstrap';
import { useSelector} from 'react-redux';
import { useDispatch } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import { base_url } from '../../../utilities';
import { getPmsStudyData ,getPmsReportsChartData,getNewPmsStudyData} from '../../../Redux/actions/actions';
import Loader from '../../ReusableComp/Loader';
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import {useNavigate } from 'react-router';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Label,
    Tooltip,
    Legend,
    RadialBarChart,
    RadialBar,
    BarChart,
    Bar,
    CartesianGrid,
    PieChart,
  Pie,
  Cell,
  } from "recharts";

const PMSAllReports = () => {
  // const colors = ["#8884d8", "#ffc658", "#82ca9d", "#83a6ed"];
  const colors = ["#ff6347", "#48d1cc", "#ff8c00", "#6a5acd", "#20b2aa", "#ff69b4", "#32cd32", "#da70d6", "#ff4500", "#00ced1", "#9370db", "#3cb371", "#ff1493", "#008080", "#8a2be2", "#008b8b", "#dda0dd", "#b8860b", "#7fff00", "#ff00ff", "#8884d8", "#ffc658", "#82ca9d", "#83a6ed"]



//****************** */
const navigate=useNavigate();
let rolecode = localStorage.getItem('role_code');
    const [listOfZones, setListOfZones] = useState([]);
    const [statesByZone, setStatesByZone] = useState([]);
    const [citiesByState, setCitiesByState] = useState([]);
    const [zoneData, setZoneData] = useState("");
    const [zoneId, setNewZoneId] = useState("");
  const [stateId, setNewStateId] = useState("");
  const [newCityId, setNewCityId] = useState("");
  const pmsReportChartData = useSelector((state) => state.pmsReportsChartData);
  const [doseChart,setDoseChart]=useState([]);
  // const [subjectChart,setSubjectChart]=useState([]);
  const [eventsChart,setEventsChart]=useState([]);
  const [listOfEvents,setListOfEvents]=useState([]);
  const [eventDoseSelect,setEventDoseSelect]=useState();
  const [listOfSaeDoes,setListOfSaeDoses]=useState([]);
  const [saeDoseSelect,setSaeDoseSelect]=useState();
  const [ageChart,setAgeChart]=useState([]);
  const [listOfAgeDoses,setListOfAgeDoses]=useState()
  const [ageDose,setAgeDose]=useState();
  const [genderChart,setGenderChart]=useState([]);
  const [genderDose,setGenderDose]=useState();
  const [listOfGenderDoses,setListOfGenderDoses]=useState();
  const [stateWiseDose, setStateWiseDose] = useState();
  const [zoneWiseDose, setZoneWiseDose] = useState();
  const [listOfZoneWiseDoses, setListOfZoneWiseDoses]=useState();
  const [listOfStateWiseDoses, setListOfStateWiseDoses]=useState();
  const [stateWiseChart, setStateWiseChart] = useState();
  const [zoneWiseChart, setZoneWiseChart] = useState();

  const [listOfSocDoses, setListOfSocDoses] = useState();
  const [socDose, setSocDose] = useState();
  const [socChart, setSocChart] = useState();

  const [listOfPtDoses, setListOfPtDoses] = useState();
  const [ptDose, setPtDose] = useState();
  const [ptChart, setPtChart] = useState();

  const [listOfSaeSocDoses, setListOfSaeSocDoses] = useState();
  const [saeSocDose, setSaeSocDose] = useState();
  const [saeSocChart, setSaeSocChart] = useState();

  const [listOfSaePtDoses, setListOfSaePtDoses] = useState();
  const [saePtDose, setSaePtDose] = useState();
  const [saePtChart, setSaePtChart] = useState();
  const [fetchLoader,setFecthLoader] = useState(false)

  const [ageChartAe,setAgeChartAe]=useState([]);
  const [listOfAgeDosesAe,setListOfAgeDosesAe]=useState()
  const [ageDoseAe,setAgeDoseAe]=useState();

  const [ageChartSae,setAgeChartSae]=useState([]);
  const [listOfAgeDosesSae,setListOfAgeDosesSae]=useState()
  const [ageDoseSae,setAgeDoseSae]=useState();

  const [genderChartAe,setGenderChartAe]=useState([]);
  const [listOfGenderDosesAe,setListOfGenderDosesAe]=useState()
  const [genderDoseAe,setGenderDoseAe]=useState();

  const [genderChartSae,setGenderChartSae]=useState([]);
  const [listOfGenderDosesSae,setListOfGenderDosesSae]=useState()
  const [genderDoseSae,setGenderDoseSae]=useState();

  const [ageChartAesi,setAgeChartAesi]=useState([]);
  const [listOfAgeDosesAesi,setListOfAgeDosesAesi]=useState()
  const [ageDoseAesi,setAgeDoseAesi]=useState();

  const [genderChartAesi,setGenderChartAesi]=useState([]);
  const [listOfGenderDosesAesi,setListOfGenderDosesAesi]=useState()
  const [genderDoseAesi,setGenderDoseAesi]=useState();

  const [actionTakenAeChart,setActionTakenAeChart]=useState([]);
  const [listOfActionTakenAeDoses,setListOfActionTakenAeDoses]=useState()
  const [actionTakenAeDose,setActionTakenAeDose]=useState();

  const [outcomesAeChart,setOutcomesAeChart]=useState([]);
  const [listOfOutcomesAe,setListOfOutcomesAe]=useState()
  const [outcomesAeDose,setOutcomesAeDose]=useState();

  const [treatmentsAeChart,setTreatmentsAeChart]=useState([]);
  const [listOfTreatmentsAe,setListOfTreatmentsAe]=useState()
  const [treatmentsAeDose,setTreatmentsAeDose]=useState();

  const [comorbiditiesAeChart,setComorbiditiesAeChart]=useState([]);
  const [listOfComorbiditiesAe,setListOfComorbiditiesAe]=useState()
  const [comorbiditiesAeDose,setComorbiditiesAeDose]=useState();

  const [classificationAeChart,setClassificationAeChart]=useState([]);
  const [listOfClassificationAe,setListOfClassificationAe]=useState()
  const [classificationAeDose,setClassificationAeDose]=useState();
  
  const [intervalsAeChart,setIntervalsAeChart]=useState([]);
  const [listOfIntervalsAe,setListOfIntervalsAe]=useState()
  const [intervalsAeDose,setIntervalsAeDose]=useState();


  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius-20;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
  
    return (
      
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize={12}>
        {value !== 0 ? value : ""}
      </text>
    );
  };

  
  const [loading, setLoading] = useState(false);
  const [tooltip, setTooltip] = useState(null);
  const [tooltip_age,setTooltipAge]=useState(null);
  const [tooltipSoc, setTooltipSoc] = useState(null);
  const [tooltipPt, setTooltipPt] = useState(null);

  const [tooltipSaeSoc, setTooltipSaeSoc] = useState(null);
  const [tooltipSaePt, setTooltipSaePt] = useState(null);
  const [tooltip_age_ae,setTooltipAgeAe]=useState(null);
  const [tooltip_age_sae,setTooltipAgeSae]=useState(null);
  const [tooltip_age_aesi,setTooltipAgeAesi]=useState(null);



  const [personName, setPersonName] = React.useState([]);
const [stateName, setstateName] = React.useState([]);
const [cityName, setCityName]=React.useState([]);
const [zones_for_api,setZonesForApi]=React.useState([]);
const [states_for_api,setStatesForApi]=React.useState([]);
const [cities_for_api,setCitiesForApi]=React.useState([]);
const [excel_zone_data,setExcelZoneData]=React.useState([]);
const [excel_state_data,setExcelStateData]=React.useState([]);
const [excel_city_data,setExcelCityData]=React.useState([]);
const [excel_site_data,setExcelSiteData]=React.useState([]);


  const intitalOptions={
    chart: {
      width: 380,
      type: "polarArea",
    },
    labels: [],
    fill: {
      colors: [],
    },
    stroke: {
      width: 1,
      colors: undefined,
    },
    yaxis: {
      show: false,
    },
    legend: {
      display: true,
      position: "right",
      labels: {
        usePointStyle: true,
        colors: [],
      },
      markers: {
        fillColors: [],
      },
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0,
        },
        spokes: {
          strokeWidth: 0,
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: {}
    },
    theme: {
      monochrome: {
        enabled: true,
        shadeTo: "light",
        shadeIntensity: 0.6,
      },
    },

  }
  const [chartData, setChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState(intitalOptions);
  const dispatch=useDispatch();

  const count = React.useRef(0)

  useEffect(() => {
    if(!window.isExpired && count.current === 0){
    setLoading(true);
    count.current = 1
    }
    if (pmsReportChartData) {
      setTimeout(()=>{
        setLoading(false);
      },600)
      setTimeout(()=>{
        count.current = 0
      },1000)
    }
  }, [localStorage.study_id]);

  useEffect(() => {
    if (pmsReportChartData) {
      setTimeout(() => {
        setLoading(false)
      }, 600);
    }
  },[pmsReportChartData])



  const colors_sub = ["#ff6347", "#48d1cc", "#ff8c00", "#6a5acd", "#20b2aa", "#ff69b4", "#32cd32", "#da70d6", "#ff4500", "#00ced1", "#9370db", "#3cb371", "#ff1493", "#008080", "#8a2be2", "#008b8b", "#dda0dd", "#b8860b", "#7fff00", "#ff00ff"]



    useEffect(() => {
      // =======all Zones============
      axios
        .post(base_url + "zones/get_all_zones")
        .then((res) => {
          setZoneData(res.data.data);
          setListOfZones(res.data.data);
        })
        .catch((err) => {
        });
      },[])
      useEffect(() => {
        dispatch(getPmsStudyData())
        dispatch(getNewPmsStudyData())
      }, [dispatch])
      const [target, setTarget] = useState()
      useEffect(()=>{
        if(!localStorage.getItem("login_user_name")){
          navigate("/");
      }
        const response=pmsReportChartData?.doseChartData;
        setTarget(pmsReportChartData?.doseChartData?.TotalSubjects)
        const subjectChartData = pmsReportChartData?.subjectChartData;
        const eventChart=pmsReportChartData?.eventChartData;
        const saeChart=pmsReportChartData?.saeChartData;
        const ageChartt=pmsReportChartData?.subjectAgeGroupChartData;
        const genderChart=pmsReportChartData?.subjectGenderChartData;
        const zoneWiseChart = pmsReportChartData?.subjectZoneWiseChartData
        const stateWiseChart = pmsReportChartData?.subjectStateWiseChartData
        const socChart = pmsReportChartData?.eventSocChartData
        const ptChart = pmsReportChartData?.eventPTChartData
        const saeSocChart = pmsReportChartData?.saeSocChartData
        const saePtChart = pmsReportChartData?.saePTChartData
        const ageChartAe = pmsReportChartData?.eventAgeChartData
        const genderChartAe = pmsReportChartData?.eventGenderChartData
        const ageChartSae = pmsReportChartData?.saeAgeChartData
        const genderChartSae = pmsReportChartData?.saeGenderChartData
        const ageChartAesi = pmsReportChartData?.aesiAgeChartData
        const genderChartAesi = pmsReportChartData?.aesiGenderChartData
        const actionTakenAeChart = pmsReportChartData?.eventActionTakenChartData
        const outcomesAeChart = pmsReportChartData?.eventOutcomeChartData
        const treatmentsAeChart = pmsReportChartData?.eventTreatmentChartData
        const comorbiditiesAeChart = pmsReportChartData?.eventComorbiditiesChartData
        const classificationAeChart = pmsReportChartData?.eventClassificationsChartData
        const intervalsAeChart = pmsReportChartData?.eventIntervalsChartData



        const convertDate = (date) => {
          const [month,year] = date.split('-');
          const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ];
          return monthNames[parseInt(month, 10) - 1] + "-" + year.slice(-2);
  
        };
    

        if(response===null || response===undefined){
        }
        else{
        const updatedData1 = Object.keys(response?.DoseInfo).map((doseNumber,index) => ({
          name: `Dose${doseNumber}`,
          subjects: response?.DoseInfo[doseNumber],
          total: response?.TotalSubjects,
          fill: colors[index],
        }));

        setDoseChart(updatedData1);
      }
    
      if(eventChart===null || eventChart===undefined){

      }
      else{
        const events = [];
        const doses=[];
        Object.keys(eventChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = eventChart[doses[0]];
          Object.keys(eventData).forEach((eventName) => {
            const eventValue = eventData[eventName];
            events.push({
              name: `${eventName}`,
              count: eventValue,
            });
          });
      setEventsChart(events);
      setListOfEvents(doses);
      setEventDoseSelect(doses[0]);
    }
    if(saeChart===null || saeChart===undefined){

    }
    else{
      let sae_doses=[];
      
      const sae_doses1 = Object.keys(saeChart);
      const firstDose = sae_doses1[0];
      const { series, labels } = transformDataToChart(saeChart[firstDose]);
      const formatter = function (val, { seriesIndex }) {
        // Calculate the percentage
        let totalSum = series.reduce((acc, seriesData) => acc + seriesData, 0);
        const percentage = totalSum !== 0?(series[seriesIndex] / totalSum) * 100 : 0;
        return percentage.toFixed(2) + "%";
      };
      const options = {
        ...chartOptions,
        labels,
        fill: {
          colors: [],
        },
        legend: {
          ...chartOptions.legend,
          labels: {
            ...chartOptions.legend.labels,
            colors:[] ,
          },
          markers: {
            ...chartOptions.legend.markers,
            fillColors: [],
          },
        },
        dataLabels: {
          enabled: true,
          formatter:function (val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
        }, // Use the formatter function
      },
      };
        // Loop through the labels and calculate the index
      labels.forEach((label, index) => {
        options.fill.colors.push(colors[index]);
        options.legend.labels.colors.push(colors[index]);
        options.legend.markers.fillColors.push(colors[index]);
      });
      Object.keys(saeChart).forEach((dose, index) => {
        sae_doses.push(dose);
      })
      setListOfSaeDoses(sae_doses);
      setSaeDoseSelect(sae_doses[0]);
     
      setChartData(series);
      setChartOptions(options);
    }
    if(ageChartt===null || ageChartt===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(ageChartt).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = ageChartt[doses[0]];
          Object.keys(eventData).forEach((eventName) => {
            const eventValue = eventData[eventName];
            events.push({
              name: `${eventName}`,
              count: eventValue,
            });
          });
      setAgeChart(events);
      setListOfAgeDoses(doses);
      setAgeDose(doses[0]);
    }
    if(ageChartAe===null || ageChartAe===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(ageChartAe).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = ageChartAe[doses[0]];
          Object.keys(eventData).forEach((eventName) => {
            const eventValue = eventData[eventName];
            events.push({
              name: `${eventName}`,
              count: eventValue,
            });
          });
      setAgeChartAe(events);
      setListOfAgeDosesAe(doses);
      setAgeDoseAe(doses[0]);
    }

    if(ageChartSae===null || ageChartSae===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(ageChartSae).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = ageChartSae[doses[0]];
          Object.keys(eventData).forEach((eventName) => {
            const eventValue = eventData[eventName];
            events.push({
              name: `${eventName}`,
              count: eventValue,
            });
          });
      setAgeChartSae(events);
      setListOfAgeDosesSae(doses);
      setAgeDoseSae(doses[0]);
    }

    if(ageChartAesi===null || ageChartAesi===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(ageChartAesi).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = ageChartAesi[doses[0]];
          Object.keys(eventData).forEach((eventName) => {
            const eventValue = eventData[eventName];
            events.push({
              name: `${eventName}`,
              count: eventValue,
            });
          });
      setAgeChartAesi(events);
      setListOfAgeDosesAesi(doses);
      setAgeDoseAesi(doses[0]);
    }
    if(genderChart===null || genderChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(genderChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = genderChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setGenderChart(events);
      setListOfGenderDoses(doses);
      setGenderDose(doses[0]);
    }

    if(intervalsAeChart===null || intervalsAeChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(intervalsAeChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = intervalsAeChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setIntervalsAeChart(events);
      setListOfIntervalsAe(doses);
      setIntervalsAeDose(doses[0]);
    }

    if(classificationAeChart===null || classificationAeChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(classificationAeChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = classificationAeChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setClassificationAeChart(events);
      setListOfClassificationAe(doses);
      setClassificationAeDose(doses[0]);
    }

    if(comorbiditiesAeChart ===null || comorbiditiesAeChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(comorbiditiesAeChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = comorbiditiesAeChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setComorbiditiesAeChart(events);
      setListOfComorbiditiesAe(doses);
      setComorbiditiesAeDose(doses[0]);
    }

    if(treatmentsAeChart===null || treatmentsAeChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(treatmentsAeChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = treatmentsAeChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setTreatmentsAeChart(events);
      setListOfTreatmentsAe(doses);
      setTreatmentsAeDose(doses[0]);
    }

    if(outcomesAeChart===null || outcomesAeChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(outcomesAeChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = outcomesAeChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setOutcomesAeChart(events);
      setListOfOutcomesAe(doses);
      setOutcomesAeDose(doses[0]);
    }

    if(actionTakenAeChart===null || actionTakenAeChart===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(actionTakenAeChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = actionTakenAeChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setActionTakenAeChart(events);
      setListOfActionTakenAeDoses(doses);
      setActionTakenAeDose(doses[0]);
    }

    if(genderChartAe===null || genderChartAe===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(genderChartAe).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = genderChartAe[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setGenderChartAe(events);
      setListOfGenderDosesAe(doses);
      setGenderDoseAe(doses[0]);
    }

    if(genderChartSae===null || genderChartSae===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(genderChartSae).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = genderChartSae[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setGenderChartSae(events);
      setListOfGenderDosesSae(doses);
      setGenderDoseSae(doses[0]);
    }

    if(genderChartAesi===null || genderChartAesi===undefined){

    }
    else{
      const events = [];
        const doses=[];
        Object.keys(genderChartAesi).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = genderChartAesi[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
      setGenderChartAesi(events);
      setListOfGenderDosesAesi(doses);
      setGenderDoseAesi(doses[0]);
    }
    if(zoneWiseChart===null || zoneWiseChart===undefined){

    }
    else{
        const events = [];
        const doses=[];
        Object.keys(zoneWiseChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = zoneWiseChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
          setZoneWiseChart(events)
          setZoneWiseDose(doses[0])
          setListOfZoneWiseDoses(doses);
          
    }
    if(stateWiseChart===null || stateWiseChart===undefined){

    }
    else{
        const events = [];
        const doses=[];
        Object.keys(stateWiseChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(eventChart).forEach((dose, index) => {
          const eventData = stateWiseChart[doses[0]];
          
          Object.keys(eventData).forEach((eventName,index) => {
            const eventValue = eventData[eventName];
            const color = colors_sub[index % colors_sub.length];
            events.push({
              name: `${eventName}`,
              value: eventValue,
              color:color
            });
          });
          setStateWiseChart(events)
          setStateWiseDose(doses[0])
          setListOfStateWiseDoses(doses);
          
    }
    if(socChart===null || socChart===undefined){

    }
    else{
      const events = [];
      const doses=[];
      Object.keys(socChart).forEach((dose, index) => {
        doses.push(dose);
      })
    
      // Object.keys(socChart).forEach((dose, index) => {
        const eventData = socChart[doses[0]];
        Object.keys(eventData).forEach((eventName) => {
          const eventValue = eventData[eventName];
          events.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
    setSocChart(events);
    setListOfSocDoses(doses);
    setSocDose(doses[0]);
  }

      if(ptChart===null || ptChart===undefined){

      }
      else{
        const events = [];
        const doses=[];
        Object.keys(ptChart).forEach((dose, index) => {
          doses.push(dose);
        })
      
        // Object.keys(ptChart).forEach((dose, index) => {
          const eventData = ptChart[doses[0]];
          Object.keys(eventData).forEach((eventName) => {
            const eventValue = eventData[eventName];
            events.push({
              name: `${eventName}`,
              count: eventValue,
            });
          });
      setPtChart(events);
      setListOfPtDoses(doses);
      setPtDose(doses[0]);
    }

    if(saeSocChart===null || saeSocChart===undefined){

    }
    else{
      const events = [];
      const doses=[];
      Object.keys(saeSocChart).forEach((dose, index) => {
        doses.push(dose);
      })
    
      // Object.keys(socChart).forEach((dose, index) => {
        const eventData = saeSocChart[doses[0]];
        Object.keys(eventData).forEach((eventName) => {
          const eventValue = eventData[eventName];
          events.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
    setSaeSocChart(events);
    setListOfSaeSocDoses(doses);
    setSaeSocDose(doses[0]);
  }

  if(saePtChart===null || saePtChart===undefined){

  }
  else{
    const events = [];
    const doses=[];
    Object.keys(saePtChart).forEach((dose, index) => {
      doses.push(dose);
    })
  
    // Object.keys(saePtChart).forEach((dose, index) => {
      const eventData = saePtChart[doses[0]];
      Object.keys(eventData).forEach((eventName) => {
        const eventValue = eventData[eventName];
        events.push({
          name: `${eventName}`,
          count: eventValue,
        });
      });
  setSaePtChart(events);
  setListOfSaePtDoses(doses);
  setSaePtDose(doses[0]);
}
      },[dispatch,pmsReportChartData])


      function transformDataToChart(saeChartData,values) {
        const series = [];
        const labels = [];
        if(!values){
        // for (const dose in saeChartData) {
        //   if (saeChartData.hasOwnProperty(dose)) {
            const events = saeChartData;
            for (const label in events) {
              if (events.hasOwnProperty(label)) {
                const value = events[label];
                if(label!=="null"){
                labels.push(label);
                series.push(value);
                }
              }
          //   }
          // }
        }
      }
        if(values){
          let data=pmsReportChartData?.saeChartData[values];
          for (const label in data) {
            if (data.hasOwnProperty(label)) {
              const value = data[label];
              if(label!=="null"){
              labels.push(label);
              series.push(value);
              }
            }
          }
        }
    
        return { series, labels };
      }

      const handleClearFilters=()=>{
        setFecthLoader(true)
      if(cityName.length!==0 || stateName.length!==0 || personName.length!==0){
        setClearFilters(true);
        if(clearFilters){
        setStatesByZone([]);
        setCitiesByState([]);
        setListOfZones([]);
        setCityName([]);
        setstateName([]);
        setPersonName([]);
        setExcelCityData([]);
        setExcelSiteData([]);
        setExcelStateData([]);
        setNewZoneId("");
        setNewStateId("");
        setNewCityId("");
        callApi();
        setClearFilters(false);
        }
        
      }
      setTimeout(() => {
        setFecthLoader(false)
      }, 1000);
      }

      const [clearFilters, setClearFilters] = useState(false);
      useEffect(() => {
        if (clearFilters) {
          handleClearFilters();
        }
      }, [clearFilters])
    
     const callApi=()=>{
      axios
        .post(base_url + "zones/get_all_zones")
        .then((res) => {
          setZoneData(res.data.data);
          setListOfZones(res.data.data);
        })
        .catch((err) => {
        });
     }

      const zone_options = listOfZones?.map((zone) => ({
        value: zone.zone_id,
        label: zone.zone_name,
      }));
      const state_options = statesByZone?.map((state) => ({
        value: state.state_id,
        label: state.state_name,
      }));

      const handleOptionSelectEventDose=(e)=>{
        setEventDoseSelect(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setEventsChart(data_event);
      }
      const handleOptionSelectGenderDose=(e)=>{
        setGenderDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.subjectGenderChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setGenderChart(data_event);
      }

      const handleOptionSelectGenderDoseAe=(e)=>{
        setGenderDoseAe(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventGenderChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setGenderChartAe(data_event);
      }
      const handleOptionSelectGenderDoseSae=(e)=>{
        setGenderDoseSae(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.saeGenderChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setGenderChartSae(data_event);
      }

      const handleOptionSelectGenderDoseAesi=(e)=>{
        setGenderDoseAesi(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.aesiGenderChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setGenderChartAesi(data_event);
      }

      const handleOptionSelectZoneWiseDose=(e)=>{
        setZoneWiseDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.subjectZoneWiseChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setZoneWiseChart(data_event);
      }

      const handleOptionSelectActionTakenAeDose=(e)=>{
        setActionTakenAeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventActionTakenChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setActionTakenAeChart(data_event);
      }

      const handleOptionSelectTreatmentAe=(e)=>{
        setTreatmentsAeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventTreatmentChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setTreatmentsAeChart(data_event);
      }

      const handleOptionSelectClassificationAe=(e)=>{
        setClassificationAeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventClassificationsChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setClassificationAeChart(data_event);
      }

      const handleOptionSelectComorbiditiesAe=(e)=>{
        setComorbiditiesAeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventComorbiditiesChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setComorbiditiesAeChart(data_event);
      }

      const handleOptionSelectIntervalsAe=(e)=>{
        setIntervalsAeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventIntervalsChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setIntervalsAeChart(data_event);
      }

      


      const handleOptionSelectStateWiseDose=(e)=>{
        setStateWiseDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.subjectStateWiseChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setStateWiseChart(data_event);
      }

      const handleOptionSelectOutcomesAe=(e)=>{
        setOutcomesAeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventOutcomeChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName,index) => {
          const eventValue = filteredData[eventName];
          const color = colors_sub[index % colors_sub.length];
          data_event.push({
            name: `${eventName}`,
            value: eventValue,
            color:color
          });
        });
        setOutcomesAeChart(data_event);
      }


      const handleOptionSelectAgeDose=(e)=>{
        setAgeDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.subjectAgeGroupChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setAgeChart(data_event);
      }

      const handleOptionSelectAgeDoseAe=(e)=>{
        setAgeDoseAe(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventAgeChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setAgeChartAe(data_event);
      }

      const handleOptionSelectAgeDoseSae=(e)=>{
        setAgeDoseSae(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.saeAgeChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setAgeChartSae(data_event);
      }

      const handleOptionSelectAgeDoseAesi=(e)=>{
        setAgeDoseAesi(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.aesiAgeChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setAgeChartAesi(data_event);
      }

      const handleOptionSelectSocDose=(e)=>{
        setSocDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventSocChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setSocChart(data_event);
      }

      const handleOptionSelectPtDose=(e)=>{
        setPtDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.eventPTChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setPtChart(data_event);
      }

      const handleOptionSelectSaeSocDose=(e)=>{
        setSaeSocDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.saeSocChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setSaeSocChart(data_event);
      }

      const handleOptionSelectSaePtDose=(e)=>{
        setSaePtDose(e.target.value);
        let data_event=[];
        const filteredData = pmsReportChartData?.saeSocChartData[e.target.value];
        Object.keys(filteredData).forEach((eventName) => {
          const eventValue = filteredData[eventName];
          data_event.push({
            name: `${eventName}`,
            count: eventValue,
          });
        });
        setSaePtChart(data_event);
      }

      const handleOptionSelectSaeDose=(e)=>{
      setSaeDoseSelect(e.target.value);
      const { series, labels } = transformDataToChart(pmsReportChartData?.saeChartData,e.target.value);
      const formatterr = function (val, opts) {
        return opts.w.globals.series[opts.seriesIndex];
    }
      
      const options = {
        ...chartOptions,
        labels,
        fill: {
          colors: [],
        },
        legend: {
          ...chartOptions.legend,
          labels: {
            ...chartOptions.legend.labels,
            colors:[] ,
          },
          markers: {
            ...chartOptions.legend.markers,
            fillColors: [],
          },
        },
        dataLabels: {
          enabled: true,
          formatter: formatterr, // Use the formatter function
        },
      };
        // Loop through the labels and calculate the index
      labels.forEach((label, index) => {
        options.fill.colors.push(colors[index]);
        options.legend.labels.colors.push(colors[index]);
        options.legend.markers.fillColors.push(colors[index]);
      });
      setChartData(series);
      setChartOptions(options);      
      }

      const handleMouseEnter = (index, coordinate) => {
        setTooltip({ index, coordinate });
      };
      
      const handleMouseLeave = () => {
        setTooltip(null);
      };

      const handleMouseEnter2 = (index, coordinate) => {
        setTooltipAge({ index, coordinate });
      };
      
      const handleMouseLeave2 = () => {
        setTooltipAge(null);
      };

      const handleMouseEnterAeAge = (index, coordinate) => {
        setTooltipAgeAe({ index, coordinate });
      };
      
      const handleMouseLeaveAeAge = () => {
        setTooltipAgeAe(null);
      };

      const handleMouseEnterSaeAge = (index, coordinate) => {
        setTooltipAgeSae({ index, coordinate });
      };
      
      const handleMouseLeaveSaeAge = () => {
        setTooltipAgeSae(null);
      };

      const handleMouseEnterAesiAge = (index, coordinate) => {
        setTooltipAgeAesi({ index, coordinate });
      };
      
      const handleMouseLeaveAesiAge = () => {
        setTooltipAgeAesi(null);
      };

      const handleMouseEnterSoc = (index, coordinate) => {
        setTooltipSoc({ index, coordinate })
      }
      const handleMouseLeaveSoc = () => {
        setTooltipSoc(null);
      };
      const handleMouseEnterPt = (index, coordinate) => {
        setTooltipPt({ index, coordinate })
      }
      const handleMouseLeavePt = () => {
        setTooltipPt(null);
      };

      const handleMouseEnterSaeSoc = (index, coordinate) => {
        setTooltipSaeSoc({ index, coordinate })
      }
      const handleMouseLeaveSaeSoc = () => {
        setTooltipSaeSoc(null);
      };
      const handleMouseEnterSaePt = (index, coordinate) => {
        setTooltipSaePt({ index, coordinate })
      }
      const handleMouseLeaveSaePt = () => {
        setTooltipSaePt(null);
      };

      

    const exportExcelDose=()=>{
      if( doseChart.length>0){
      const studyName = `Study Name:${localStorage.getItem("study_name")}`;
      
            const updatedData = Object.keys(pmsReportChartData.doseChartData?.DoseInfo)
        .filter(doseNumber => {
          const doseInfo = pmsReportChartData.doseChartData?.DoseInfo[doseNumber];
          return doseInfo !== null && doseInfo !== undefined;
        })
        .map(doseNumber => {
          const totalSubjects = pmsReportChartData.doseChartData?.TotalSubjects;
          const doseInfo = pmsReportChartData.doseChartData?.DoseInfo[doseNumber];
          
          const percentage = ((doseInfo / totalSubjects) * 100).toFixed(2) + '%';
          
          return [`Dose${doseNumber}`, totalSubjects, doseInfo, percentage];
        });


      const excelData = [
        ['',studyName],
        ['', 'Estimated subjects', 'Subjects enrolled', '%'],
        ...updatedData,
      ];
       // create the data that you want to write to the excel file
    const data = excelData;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(data);


    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "StudyDosesList.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
      }
      else{
        const studyName = `Study Name:${localStorage.getItem("study_name")}`;
        const excelData = [
          ['',studyName],
          ['', 'Estimated subjects', 'Subjects enrolled', '%'],
          ['DoseInfo',0,0,"0%"],
        ];
         // create the data that you want to write to the excel file
      const data = excelData;
  
      // create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(data);
  
  
      // create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // create the excel file and save it to the user's device
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
      const fileName = "StudyDosesList.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
      }
    }

    const exportExcelAge=()=>{
      if(ageChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.subjectAgeGroupChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.subjectAgeGroupChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.subjectAgeGroupChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.subjectAgeGroupChartData) {
          const count = pmsReportChartData?.subjectAgeGroupChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.subjectAgeGroupChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.subjectAgeGroupChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Age_wise_subject_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    const exportExcelAgeAe=()=>{
      if(ageChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventAgeChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventAgeChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventAgeChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventAgeChartData) {
          const count = pmsReportChartData?.eventAgeChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventAgeChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventAgeChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Age_wise_Adverse_Events_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    const exportExcelAgeAesi=()=>{
      if(ageChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.aesiAgeChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.aesiAgeChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.aesiAgeChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.aesiAgeChartData) {
          const count = pmsReportChartData?.aesiAgeChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.aesiAgeChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.aesiAgeChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Age_wise_Adverse_Events_Special_Intrest_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }


    const exportExcelSaeAge=()=>{
      if(ageChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.saeAgeChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.saeAgeChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.saeAgeChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.saeAgeChartData) {
          const count = pmsReportChartData?.saeAgeChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.saeAgeChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.saeAgeChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Overall_Serious_Adverse_Events_Age.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }


    const exportExcelGender=()=>{
      if(genderChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.subjectGenderChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.subjectGenderChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.subjectGenderChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.subjectGenderChartData) {
          const count = pmsReportChartData?.subjectGenderChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.subjectGenderChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.subjectGenderChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Gender_wise_subject_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    // =============zone wise subject count doc
    const exportExcelZoneWiseSubjectCount=()=>{
      if(zoneWiseChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.subjectZoneWiseChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.subjectZoneWiseChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.subjectZoneWiseChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.subjectZoneWiseChartData) {
          const count = pmsReportChartData?.subjectZoneWiseChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.subjectZoneWiseChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.subjectZoneWiseChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Zone_wise_subject_Count.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    // ========================

    const exportExcelActionTakenAe=()=>{
      if(actionTakenAeChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventActionTakenChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventActionTakenChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventActionTakenChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventActionTakenChartData) {
          const count = pmsReportChartData?.eventActionTakenChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventActionTakenChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventActionTakenChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Adverse_Events_Per_Action_Taken.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    const exportExcelTreatmentsAe=()=>{
      if(treatmentsAeChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventTreatmentChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventTreatmentChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventTreatmentChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventTreatmentChartData) {
          const count = pmsReportChartData?.eventTreatmentChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventTreatmentChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventTreatmentChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Treatments_Given_For_Adverse_Events.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    const exportExcelIntervalsAe=()=>{
      if(intervalsAeChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventIntervalsChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventIntervalsChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventIntervalsChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventIntervalsChartData) {
          const count = pmsReportChartData?.eventIntervalsChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventIntervalsChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventIntervalsChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Adverse_Events_Intervals.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    const exportExcelClassificationAe=()=>{
      if(classificationAeChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventClassificationsChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventClassificationsChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventClassificationsChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventClassificationsChartData) {
          const count = pmsReportChartData?.eventClassificationsChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventClassificationsChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventClassificationsChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Classifications_Adverse_Events.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }

    const exportExcelComorbiditiesAe=()=>{
      if(comorbiditiesAeChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventComorbiditiesChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventComorbiditiesChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventComorbiditiesChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventComorbiditiesChartData) {
          const count = pmsReportChartData?.eventComorbiditiesChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventComorbiditiesChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventComorbiditiesChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "Comorbidities_Adverse_Events.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
    }
// ======================== State Wise subject Count doc

const exportExcelStateWiseSubjectCount=()=>{
  if(genderChart.length>0 ){
  const study_name=`Study Name:${localStorage.getItem("study_name")}`;
  const doseNames = Object.keys(pmsReportChartData?.subjectStateWiseChartData);
  // Extract unique adverse event names
  const adverseEventNames = Array.from(
    new Set(
      Object.keys(pmsReportChartData?.subjectStateWiseChartData).reduce((names, dose) => {
        return names.concat(Object.keys(pmsReportChartData?.subjectStateWiseChartData[dose]));
      }, [])
    )
  );

  // Create an array for the dynamic headers
  const headers = ["",study_name];
  const dosesRow = ["", ...doseNames, 'total'];
  // Create an array to hold the adverse event data
  const adverseEventData = [];

  // Populate the adverse event data row-wise starting from the third row
  for (const adverseEvent of adverseEventNames) {
    if(adverseEvent!=="null"){
    const rowData = [adverseEvent];
    for (const dose in pmsReportChartData?.subjectStateWiseChartData) {
      const count = pmsReportChartData?.subjectStateWiseChartData[dose][adverseEvent] || 0;
      rowData.push(count);
    }
    const total = Array.from(Object.keys(pmsReportChartData?.subjectStateWiseChartData)).reduce((sum, dose) => {
      return sum + (pmsReportChartData?.subjectStateWiseChartData[dose][adverseEvent] || 0);
    }, 0);
    rowData.push(total);

    adverseEventData.push(rowData);
  }
}
  // Create the Excel data array with headers, doses, and adverse event data
  const excelData_adverse = [headers, dosesRow, ...adverseEventData];
    // create a worksheet and add the data to it
const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);



// create a workbook and add the worksheet to it
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

// create the excel file and save it to the user's device
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileName = "State_wise_subject_Count.xlsx";
const file = new Blob(
  [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
  { type: fileType }
);
FileSaver.saveAs(file, fileName);
 }
}

const exportExcelOutcomesAe=()=>{
  if(genderChart.length>0 ){
  const study_name=`Study Name:${localStorage.getItem("study_name")}`;
  const doseNames = Object.keys(pmsReportChartData?.eventOutcomeChartData);
  // Extract unique adverse event names
  const adverseEventNames = Array.from(
    new Set(
      Object.keys(pmsReportChartData?.eventOutcomeChartData).reduce((names, dose) => {
        return names.concat(Object.keys(pmsReportChartData?.eventOutcomeChartData[dose]));
      }, [])
    )
  );

  // Create an array for the dynamic headers
  const headers = ["",study_name];
  const dosesRow = ["", ...doseNames, 'total'];
  // Create an array to hold the adverse event data
  const adverseEventData = [];

  // Populate the adverse event data row-wise starting from the third row
  for (const adverseEvent of adverseEventNames) {
    if(adverseEvent!=="null"){
    const rowData = [adverseEvent];
    for (const dose in pmsReportChartData?.eventOutcomeChartData) {
      const count = pmsReportChartData?.eventOutcomeChartData[dose][adverseEvent] || 0;
      rowData.push(count);
    }
    const total = Array.from(Object.keys(pmsReportChartData?.eventOutcomeChartData)).reduce((sum, dose) => {
      return sum + (pmsReportChartData?.eventOutcomeChartData[dose][adverseEvent] || 0);
    }, 0);
    rowData.push(total);

    adverseEventData.push(rowData);
  }
}
  // Create the Excel data array with headers, doses, and adverse event data
  const excelData_adverse = [headers, dosesRow, ...adverseEventData];
    // create a worksheet and add the data to it
const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);



// create a workbook and add the worksheet to it
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

// create the excel file and save it to the user's device
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileName = "Adverse_Events_Per_Outcomes.xlsx";
const file = new Blob(
  [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
  { type: fileType }
);
FileSaver.saveAs(file, fileName);
 }
}

const exportExcelAesiGender=()=>{
  if(genderChart.length>0 ){
  const study_name=`Study Name:${localStorage.getItem("study_name")}`;
  const doseNames = Object.keys(pmsReportChartData?.aesiGenderChartData);
  // Extract unique adverse event names
  const adverseEventNames = Array.from(
    new Set(
      Object.keys(pmsReportChartData?.aesiGenderChartData).reduce((names, dose) => {
        return names.concat(Object.keys(pmsReportChartData?.aesiGenderChartData[dose]));
      }, [])
    )
  );

  // Create an array for the dynamic headers
  const headers = ["",study_name];
  const dosesRow = ["", ...doseNames, 'total'];
  // Create an array to hold the adverse event data
  const adverseEventData = [];

  // Populate the adverse event data row-wise starting from the third row
  for (const adverseEvent of adverseEventNames) {
    if(adverseEvent!=="null"){
    const rowData = [adverseEvent];
    for (const dose in pmsReportChartData?.aesiGenderChartData) {
      const count = pmsReportChartData?.aesiGenderChartData[dose][adverseEvent] || 0;
      rowData.push(count);
    }
    const total = Array.from(Object.keys(pmsReportChartData?.aesiGenderChartData)).reduce((sum, dose) => {
      return sum + (pmsReportChartData?.aesiGenderChartData[dose][adverseEvent] || 0);
    }, 0);
    rowData.push(total);

    adverseEventData.push(rowData);
  }
}
  // Create the Excel data array with headers, doses, and adverse event data
  const excelData_adverse = [headers, dosesRow, ...adverseEventData];
    // create a worksheet and add the data to it
const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);



// create a workbook and add the worksheet to it
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

// create the excel file and save it to the user's device
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileName = "Gender_Wise_Adverse_Events_Special_Intrest.xlsx";
const file = new Blob(
  [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
  { type: fileType }
);
FileSaver.saveAs(file, fileName);
 }
}

const exportExcelSaeGender=()=>{
  if(genderChart.length>0 ){
  const study_name=`Study Name:${localStorage.getItem("study_name")}`;
  const doseNames = Object.keys(pmsReportChartData?.saeGenderChartData);
  // Extract unique adverse event names
  const adverseEventNames = Array.from(
    new Set(
      Object.keys(pmsReportChartData?.saeGenderChartData).reduce((names, dose) => {
        return names.concat(Object.keys(pmsReportChartData?.saeGenderChartData[dose]));
      }, [])
    )
  );

  // Create an array for the dynamic headers
  const headers = ["",study_name];
  const dosesRow = ["", ...doseNames, 'total'];
  // Create an array to hold the adverse event data
  const adverseEventData = [];

  // Populate the adverse event data row-wise starting from the third row
  for (const adverseEvent of adverseEventNames) {
    if(adverseEvent!=="null"){
    const rowData = [adverseEvent];
    for (const dose in pmsReportChartData?.saeGenderChartData) {
      const count = pmsReportChartData?.saeGenderChartData[dose][adverseEvent] || 0;
      rowData.push(count);
    }
    const total = Array.from(Object.keys(pmsReportChartData?.saeGenderChartData)).reduce((sum, dose) => {
      return sum + (pmsReportChartData?.saeGenderChartData[dose][adverseEvent] || 0);
    }, 0);
    rowData.push(total);

    adverseEventData.push(rowData);
  }
}
  // Create the Excel data array with headers, doses, and adverse event data
  const excelData_adverse = [headers, dosesRow, ...adverseEventData];
    // create a worksheet and add the data to it
const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);



// create a workbook and add the worksheet to it
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

// create the excel file and save it to the user's device
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileName = "Overall_Serious_Adverse_Events_Gender.xlsx";
const file = new Blob(
  [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
  { type: fileType }
);
FileSaver.saveAs(file, fileName);
 }
}

const exportExcelAeGender=()=>{
  if(genderChart.length>0 ){
  const study_name=`Study Name:${localStorage.getItem("study_name")}`;
  const doseNames = Object.keys(pmsReportChartData?.eventGenderChartData);
  // Extract unique adverse event names
  const adverseEventNames = Array.from(
    new Set(
      Object.keys(pmsReportChartData?.eventGenderChartData).reduce((names, dose) => {
        return names.concat(Object.keys(pmsReportChartData?.eventGenderChartData[dose]));
      }, [])
    )
  );

  // Create an array for the dynamic headers
  const headers = ["",study_name];
  const dosesRow = ["", ...doseNames, 'total'];
  // Create an array to hold the adverse event data
  const adverseEventData = [];

  // Populate the adverse event data row-wise starting from the third row
  for (const adverseEvent of adverseEventNames) {
    if(adverseEvent!=="null"){
    const rowData = [adverseEvent];
    for (const dose in pmsReportChartData?.eventGenderChartData) {
      const count = pmsReportChartData?.eventGenderChartData[dose][adverseEvent] || 0;
      rowData.push(count);
    }
    const total = Array.from(Object.keys(pmsReportChartData?.eventGenderChartData)).reduce((sum, dose) => {
      return sum + (pmsReportChartData?.eventGenderChartData[dose][adverseEvent] || 0);
    }, 0);
    rowData.push(total);

    adverseEventData.push(rowData);
  }
}
  // Create the Excel data array with headers, doses, and adverse event data
  const excelData_adverse = [headers, dosesRow, ...adverseEventData];
    // create a worksheet and add the data to it
const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);



// create a workbook and add the worksheet to it
const workbook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

// create the excel file and save it to the user's device
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

const fileName = "Overall_Adverse_Events_Gender.xlsx";
const file = new Blob(
  [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
  { type: fileType }
);
FileSaver.saveAs(file, fileName);
 }
}


// =========================================
  
     const exportExcelAdverse=()=>{
      if(eventsChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventChartData) {
          const count = pmsReportChartData?.eventChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "AdverseEventsList.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
     else{
      
        const study_name=`Study Name:${localStorage.getItem("study_name")}`;
        const doseNames = Object.keys(pmsReportChartData?.eventChartData);
        // Extract unique adverse event names
        const adverseEventNames = Array.from(
          new Set(
            Object.keys(pmsReportChartData?.eventChartData).reduce((names, dose) => {
              return names.concat(Object.keys(pmsReportChartData?.eventChartData[dose]));
            }, [])
          )
        );
  
        // Create an array for the dynamic headers
        const headers = ["",study_name];
        const dosesRow = ["", ...doseNames, 'total'];
        // Create an array to hold the adverse event data
        const adverseEventData = [];


        // Create an array with 0 values for each doseName and 'total'
        const zeroValuesRow = ["", ...Array(doseNames.length).fill(0), 0];

        // Populate adverseEventData with zeroValuesRow
        for (let i = 0; i < 1; i++) {
            adverseEventData.push([...zeroValuesRow]);
        }
        
        // Create the Excel data array with headers, doses, and adverse event data
        const excelData_adverse = [headers, dosesRow, ...adverseEventData];
          // create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);
  
  
    
      // create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // create the excel file and save it to the user's device
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
      const fileName = "AdverseEventsList.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
      
     }
    }

    const exportExcelSoc=()=>{
      if(socChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventSocChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventSocChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventSocChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventSocChartData) {
          const count = pmsReportChartData?.eventSocChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventSocChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventSocChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "AdverseEventsBySOC.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
     else{
      
        const study_name=`Study Name:${localStorage.getItem("study_name")}`;
        const doseNames = Object.keys(pmsReportChartData?.eventSocChartData);
        // Extract unique adverse event names
        const adverseEventNames = Array.from(
          new Set(
            Object.keys(pmsReportChartData?.eventSocChartData).reduce((names, dose) => {
              return names.concat(Object.keys(pmsReportChartData?.eventSocChartData[dose]));
            }, [])
          )
        );
  
        // Create an array for the dynamic headers
        const headers = ["",study_name];
        const dosesRow = ["", ...doseNames, 'total'];
        // Create an array to hold the adverse event data
        const adverseEventData = [];


        // Create an array with 0 values for each doseName and 'total'
        const zeroValuesRow = ["", ...Array(doseNames.length).fill(0), 0];

        // Populate adverseEventData with zeroValuesRow
        for (let i = 0; i < 1; i++) {
            adverseEventData.push([...zeroValuesRow]);
        }
        
        // Create the Excel data array with headers, doses, and adverse event data
        const excelData_adverse = [headers, dosesRow, ...adverseEventData];
          // create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);
  
  
    
      // create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // create the excel file and save it to the user's device
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
      const fileName = "AdverseEventsBySOC.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
      
     }
    }

    const exportExcelPt=()=>{
      if(ptChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.eventPTChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.eventPTChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.eventPTChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.eventPTChartData) {
          const count = pmsReportChartData?.eventPTChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.eventPTChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.eventPTChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "AdverseEventsByPt.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
     else{
      
        const study_name=`Study Name:${localStorage.getItem("study_name")}`;
        const doseNames = Object.keys(pmsReportChartData?.eventPTChartData);
        // Extract unique adverse event names
        const adverseEventNames = Array.from(
          new Set(
            Object.keys(pmsReportChartData?.eventPTChartData).reduce((names, dose) => {
              return names.concat(Object.keys(pmsReportChartData?.eventPTChartData[dose]));
            }, [])
          )
        );
  
        // Create an array for the dynamic headers
        const headers = ["",study_name];
        const dosesRow = ["", ...doseNames, 'total'];
        // Create an array to hold the adverse event data
        const adverseEventData = [];


        // Create an array with 0 values for each doseName and 'total'
        const zeroValuesRow = ["", ...Array(doseNames.length).fill(0), 0];

        // Populate adverseEventData with zeroValuesRow
        for (let i = 0; i < 1; i++) {
            adverseEventData.push([...zeroValuesRow]);
        }
        
        // Create the Excel data array with headers, doses, and adverse event data
        const excelData_adverse = [headers, dosesRow, ...adverseEventData];
          // create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);
  
  
    
      // create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // create the excel file and save it to the user's device
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
      const fileName = "AdverseEventsByPt.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
      
     }
    }

    const exportExcelSaeSoc=()=>{
      if(saeSocChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.saeSocChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.saeSocChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.saeSocChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.saeSocChartData) {
          const count = pmsReportChartData?.saeSocChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.saeSocChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.saeSocChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "SeriousAdverseEventsBySOC.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
     else{
      
        const study_name=`Study Name:${localStorage.getItem("study_name")}`;
        const doseNames = Object.keys(pmsReportChartData?.saeSocChartData);
        // Extract unique adverse event names
        const adverseEventNames = Array.from(
          new Set(
            Object.keys(pmsReportChartData?.saeSocChartData).reduce((names, dose) => {
              return names.concat(Object.keys(pmsReportChartData?.saeSocChartData[dose]));
            }, [])
          )
        );
  
        // Create an array for the dynamic headers
        const headers = ["",study_name];
        const dosesRow = ["", ...doseNames, 'total'];
        // Create an array to hold the adverse event data
        const adverseEventData = [];


        // Create an array with 0 values for each doseName and 'total'
        const zeroValuesRow = ["", ...Array(doseNames.length).fill(0), 0];

        // Populate adverseEventData with zeroValuesRow
        for (let i = 0; i < 1; i++) {
            adverseEventData.push([...zeroValuesRow]);
        }
        
        // Create the Excel data array with headers, doses, and adverse event data
        const excelData_adverse = [headers, dosesRow, ...adverseEventData];
          // create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);
  
  
    
      // create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // create the excel file and save it to the user's device
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
      const fileName = "SeriousAdverseEventsBySOC.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
      
     }
    }

    const exportExcelSaePt=()=>{
      if(saePtChart.length>0 ){
      const study_name=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames = Object.keys(pmsReportChartData?.saePTChartData);
      // Extract unique adverse event names
      const adverseEventNames = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.saePTChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.saePTChartData[dose]));
          }, [])
        )
      );

      // Create an array for the dynamic headers
      const headers = ["",study_name];
      const dosesRow = ["", ...doseNames, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent of adverseEventNames) {
        if(adverseEvent!=="null"){
        const rowData = [adverseEvent];
        for (const dose in pmsReportChartData?.saePTChartData) {
          const count = pmsReportChartData?.saePTChartData[dose][adverseEvent] || 0;
          rowData.push(count);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.saePTChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.saePTChartData[dose][adverseEvent] || 0);
        }, 0);
        rowData.push(total);

        adverseEventData.push(rowData);
      }
    }
      // Create the Excel data array with headers, doses, and adverse event data
      const excelData_adverse = [headers, dosesRow, ...adverseEventData];
        // create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);


  
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "SeriousAdverseEventsByPt.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
     }
     else{
      
        const study_name=`Study Name:${localStorage.getItem("study_name")}`;
        const doseNames = Object.keys(pmsReportChartData?.saePTChartData);
        // Extract unique adverse event names
        const adverseEventNames = Array.from(
          new Set(
            Object.keys(pmsReportChartData?.saePTChartData).reduce((names, dose) => {
              return names.concat(Object.keys(pmsReportChartData?.saePTChartData[dose]));
            }, [])
          )
        );
  
        // Create an array for the dynamic headers
        const headers = ["",study_name];
        const dosesRow = ["", ...doseNames, 'total'];
        // Create an array to hold the adverse event data
        const adverseEventData = [];


        // Create an array with 0 values for each doseName and 'total'
        const zeroValuesRow = ["", ...Array(doseNames.length).fill(0), 0];

        // Populate adverseEventData with zeroValuesRow
        for (let i = 0; i < 1; i++) {
            adverseEventData.push([...zeroValuesRow]);
        }
        
        // Create the Excel data array with headers, doses, and adverse event data
        const excelData_adverse = [headers, dosesRow, ...adverseEventData];
          // create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);
  
  
    
      // create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      // create the excel file and save it to the user's device
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  
      const fileName = "SeriousAdverseEventsByPt.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
      
     }
    }

     const exportExcelSeriousAdverse=()=>{
      if(chartData.length>0){
      const study_name_sae=`Study Name:${localStorage.getItem("study_name")}`;
      const doseNames_sae = Object.keys(pmsReportChartData?.saeChartData);
      // Extract unique adverse event names
      const adverseEventNames_sae = Array.from(
        new Set(
          Object.keys(pmsReportChartData?.saeChartData).reduce((names, dose) => {
            return names.concat(Object.keys(pmsReportChartData?.saeChartData[dose]));
          }, [])
        )
      );


      // Create an array for the dynamic headers
      const headers_sae = ["",study_name_sae];
      const dosesRow_sae = ["", ...doseNames_sae, 'total'];
      // Create an array to hold the adverse event data
      const adverseEventData_sae = [];

      // Populate the adverse event data row-wise starting from the third row
      for (const adverseEvent_sae of adverseEventNames_sae) {      
        if(adverseEvent_sae!=="null"){
        const rowData_sae = [adverseEvent_sae];
        for (const dose in pmsReportChartData?.saeChartData) {
          const count_sae = pmsReportChartData?.saeChartData[dose][adverseEvent_sae] || 0;
          rowData_sae.push(count_sae);
        }
        const total = Array.from(Object.keys(pmsReportChartData?.saeChartData)).reduce((sum, dose) => {
          return sum + (pmsReportChartData?.saeChartData[dose][adverseEvent_sae] || 0);
        }, 0);
        rowData_sae.push(total);

        adverseEventData_sae.push(rowData_sae);
      }
    }
        // Create the Excel data array with headers, doses, and adverse event data
        const excelData_adverse = [headers_sae, dosesRow_sae, ...adverseEventData_sae];
              // create a worksheet and add the data to it
          const worksheet = XLSX.utils.aoa_to_sheet(excelData_adverse);
          // create a workbook and add the worksheet to it
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // create the excel file and save it to the user's device
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

          const fileName = "SeriousAdverseEventsList.xlsx";
          const file = new Blob(
            [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
            { type: fileType }
          );
          FileSaver.saveAs(file, fileName);
     }
    }



const exportExcelSubjects=()=>{
  if(excel_zone_data.length!==0 && excel_state_data.length===0 && excel_city_data.length===0  && excel_site_data.length===0){
    const allDates = new Set();
    for (const regionData of Object.values(excel_zone_data["ZonewisesubjectsEnrolled"])) {
      for (const date in regionData) {
        allDates.add(date);
      }
    }
    const headers = ['Zone', ...Array.from(allDates)];
  const rows = [];

  // Loop through the regions
  for (const region in excel_zone_data["ZonewisesubjectsEnrolled"]) {
    const row = [region];
    for (const month in excel_zone_data["ZonewisesubjectsEnrolled"][region]) {
      row.push(excel_zone_data["ZonewisesubjectsEnrolled"][region][month]);
    }
    rows.push(row);
  }

  // Add the total row
  const totalRow = ['Total'];
  for (let i = 1; i <= headers.length - 1; i++) {
    const sum = rows.reduce((acc, row) => acc + row[i], 0);
    totalRow.push(sum);
  }
  rows.push(totalRow);

  // Create the Excel data
  const excelData = [headers, ...rows];

  // Create a worksheet and add the data to it
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);

  // Create a workbook and add the worksheet to it
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Create the Excel file and save it to the user's device
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileName = "ZonewiseEnrolledSubjects.xlsx";
  const file = new Blob(
    [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
    { type: fileType }
  );
  FileSaver.saveAs(file, fileName);
  }
  else if(excel_zone_data.length!==0 && excel_state_data.length!==0 && excel_city_data.length===0){
    const allDates = new Set();
    for (const regionData of Object.values(excel_state_data["StatewisesubjectsEnrolled"])) {
      for (const date in regionData) {
        allDates.add(date);
      }
    }
    const headers = ['State', ...Array.from(allDates)];
    const rows = [];
  
    // Loop through the regions
    for (const region in excel_state_data["StatewisesubjectsEnrolled"]) {
      const row = [region];
      for (const month in excel_state_data["StatewisesubjectsEnrolled"][region]) {
        row.push(excel_state_data["StatewisesubjectsEnrolled"][region][month]);
      }
      rows.push(row);
    }
  
    // Add the total row
    const totalRow = ['Total'];
    for (let i = 1; i <= headers.length - 1; i++) {
      const sum = rows.reduce((acc, row) => acc + row[i], 0);
      totalRow.push(sum);
    }
    rows.push(totalRow);
  
    // Create the Excel data
    const excelData = [headers, ...rows];
  
    // Create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  
    // Create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    // Create the Excel file and save it to the user's device
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileName = "StatewiseEnrolledSubjects.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  else if(excel_zone_data.length!==0 && excel_state_data.length!==0 && excel_city_data.length!==0 && excel_site_data.length===0){
    const allDates = new Set();
    for (const regionData of Object.values(excel_city_data["CitywisesubjectsEnrolled"])) {
      for (const date in regionData) {
        allDates.add(date);
      }
    }
    const headers = ['City', ...Array.from(allDates)];
    const rows = [];
  
    // Loop through the regions
    for (const region in excel_city_data["CitywisesubjectsEnrolled"]) {
      const row = [region];
      for (const month in excel_city_data["CitywisesubjectsEnrolled"][region]) {
        row.push(excel_city_data["CitywisesubjectsEnrolled"][region][month]);
      }
      rows.push(row);
    }
  
    // Add the total row
    const totalRow = ['Total'];
    for (let i = 1; i <= headers.length - 1; i++) {
      const sum = rows.reduce((acc, row) => acc + row[i], 0);
      totalRow.push(sum);
    }
    rows.push(totalRow);
  
    // Create the Excel data
    const excelData = [headers, ...rows];
  
    // Create a worksheet and add the data to it
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  
    // Create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    // Create the Excel file and save it to the user's device
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileName = "CitywiseEnrolledSubjects.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
    }
  else if(excel_zone_data.length!==0 && excel_state_data.length!==0 && excel_city_data.length!==0 && excel_site_data.length!==0){
      const allDates = new Set();
      for (const regionData of Object.values(excel_site_data["SitewisesubjectsEnrolled"])) {
        for (const date in regionData) {
          allDates.add(date);
        }
      }
      const headers = ['Site', ...Array.from(allDates)];
      const rows = [];
    
      // Loop through the regions
      for (const region in excel_site_data["SitewisesubjectsEnrolled"]) {
        const row = [region];
        for (const month in excel_site_data["SitewisesubjectsEnrolled"][region]) {
          row.push(excel_site_data["SitewisesubjectsEnrolled"][region][month]);
        }
        rows.push(row);
      }
    
      // Add the total row
      const totalRow = ['Total'];
      for (let i = 1; i <= headers.length - 1; i++) {
        const sum = rows.reduce((acc, row) => acc + row[i], 0);
        totalRow.push(sum);
      }
      rows.push(totalRow);
    
      // Create the Excel data
      const excelData = [headers, ...rows];
    
      // Create a worksheet and add the data to it
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    
      // Create a workbook and add the worksheet to it
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
      // Create the Excel file and save it to the user's device
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileName = "SitewiseEnrolledSubjects.xlsx";
      const file = new Blob(
        [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
        { type: fileType }
      );
      FileSaver.saveAs(file, fileName);
  }
  

}

  const handleChangeZone = (event) => {
    const {
      target: { value },
    } = event;

    const selectedOptions = zone_options.filter(option => value.includes(option.label));
     // Extract the 'value' properties from the selected options
  const selectedValues = selectedOptions.map((option) => option.value);

  if(selectedValues!==null){
    setFecthLoader(true)
    axios
      .post(base_url + "states/get_states_by_zone", {
        zone_id: selectedValues,
      })
      .then((res) => {
        setStatesByZone(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    }
    if(selectedValues!==null && selectedValues.length!==0){
      setZonesForApi(selectedValues);
    dispatch(getPmsReportsChartData(localStorage.study_id, selectedValues));
    setTimeout(() => {
      setFecthLoader(false)
    }, 1000);
    }
    setPersonName(
      typeof value === 'string' ? value.split(',') : value,
    );
    if (personName) {
      const hasMatchingCity = stateName.includes(personName);
      if(!hasMatchingCity){
        setstateName([]);
        setCityName([]);
      }
    }
  };

  const handleChangeState = (event) => {
    // if(stateName.length==0){
    //   setCityName("")
    // }
    setFecthLoader(true)
    const {
      target: { value },
    } = event;
    const selectedOptions = state_options.filter(option => value.includes(option.label));
     // Extract the 'value' properties from the selected options
  const selectedValues = selectedOptions.map((option) => option.value);

  if(selectedValues!==null){
    axios
      .post(base_url + "cities/get_cities_by_state_for_reports", {
        state_id: selectedValues,
      })
      .then((res) => {
        setCitiesByState(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    }
    if(selectedValues!==null && selectedValues.length!==0 && zones_for_api!==null && zones_for_api.length!==0){
      setStatesForApi(selectedValues);
      dispatch(getPmsReportsChartData(localStorage.study_id,zones_for_api,selectedValues));
      setTimeout(() => {
        setFecthLoader(false)
      }, 1000);
    }
    setstateName(
      typeof value === 'string' ? value.split(',') : value,
    );
    if (stateName) {
      const hasMatchingCity = cityName.includes(selectedValues);
      if(!hasMatchingCity){
        setCityName([])
      }
    }
   
  };

  const handleChangeCity = (event) => {
    setFecthLoader(true)
    const {
      target: { value },
    } = event;
    const selectedOptions = citiesByState.filter(option => value.includes(option.label));
     // Extract the 'value' properties from the selected options
  const selectedValues = selectedOptions.map((option) => option.value);

    if(selectedValues!==null && selectedValues.length!==0 && zones_for_api!==null && zones_for_api.length!==0 && states_for_api!==null && states_for_api.length!==0){
      setCitiesForApi(selectedValues);
      dispatch(getPmsReportsChartData(localStorage.study_id,zones_for_api,states_for_api,selectedValues));
      setTimeout(() => {
        setFecthLoader(false)
      }, 1000);
    }
    else{
      setCitiesForApi([]);
    }
    setCityName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150
      }
    }
  };
  

  useEffect(() => {
    if (personName.length === 0) {
      setExcelStateData([]);
      setExcelCityData([]);
      dispatch(getPmsReportsChartData(localStorage.study_id));
      if (stateName.length > 0) {
        setstateName([]);
      }
    }
   
  
  
    else if (stateName.length === 0) {
      setExcelCityData([]);
      if (cityName.length > 0 || citiesByState.length > 0) {
        setCityName([]);
        setCitiesByState([]);
      }
      dispatch(getPmsReportsChartData(localStorage.study_id,zones_for_api));
    }
    else if(cityName.length===0){
      if(stateName.length>0 && personName.length>0){
        dispatch(getPmsReportsChartData(localStorage.study_id,zones_for_api,states_for_api));
      }
    }
    else if(personName.length>0){
      if(stateName.length===0 && cityName.length===0){
      dispatch(getPmsReportsChartData(localStorage.study_id,zones_for_api));
      }
    }
  }, [personName, stateName, cityName]);
  
  const [dataFinal,setDataFinal]=useState([]);
        useEffect(()=>{
          const data3=[]

          if (pmsReportChartData?.subjectChartData && pmsReportChartData?.subjectChartData.StatewisesubjectsEnrolled) {
            const keys = Object.keys(pmsReportChartData?.subjectChartData?.StatewisesubjectsEnrolled);
            const datesSet = new Set();
  
            keys.forEach(key => {
              const keyDates = Object.keys(pmsReportChartData?.subjectChartData?.StatewisesubjectsEnrolled[key]);
              keyDates.forEach(date => {
                datesSet.add(date);
              });
            });
            
            // Convert the Set back to an array
            const dates = Array.from(datesSet);
    
    
  const sites = {};
  
  dates.forEach((date) => {
    const dateObject = {};
  
    for (var i = 0; i < keys.length; i++) {
      const siteValue = pmsReportChartData?.subjectChartData?.StatewisesubjectsEnrolled[keys[i]][date];
      if(siteValue!==undefined){
      dateObject[keys[i]] = siteValue;
      }
    }
  
    sites[date] = {
      name: date,
      ...dateObject
    };
  
    
  });
  
  for (const key in sites) {
    if (sites.hasOwnProperty(key)) {
      const siteObject = sites[key];
      if (siteObject.name) {
        const [month, year] = siteObject.name.split('-');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthName = monthNames[parseInt(month, 10) - 1];
        siteObject.name = `${monthName}-${year}`;
      }
      data3.push(siteObject); // Print the key (date)
    }
  }
  setDataFinal(data3)
  setExcelStateData(pmsReportChartData?.subjectChartData);
          } else if (pmsReportChartData?.subjectChartData && pmsReportChartData?.subjectChartData.CitywisesubjectsEnrolled) {
            const keys = Object.keys(pmsReportChartData?.subjectChartData?.CitywisesubjectsEnrolled);
            const datesSet = new Set();
  
            keys.forEach(key => {
              const keyDates = Object.keys(pmsReportChartData?.subjectChartData?.CitywisesubjectsEnrolled[key]);
              keyDates.forEach(date => {
                datesSet.add(date);
              });
            });
            
            // Convert the Set back to an array
            const dates = Array.from(datesSet);
    
    
  const sites = {};
  
  dates.forEach((date) => {
    const dateObject = {};
  
    for (var i = 0; i < keys.length; i++) {
      const siteValue = pmsReportChartData?.subjectChartData?.CitywisesubjectsEnrolled[keys[i]][date];
      if(siteValue!==undefined){
      dateObject[keys[i]] = siteValue;
      }
    }
  
    sites[date] = {
      name: date,
      ...dateObject
    };
  
    
  });
  
  for (const key in sites) {
    if (sites.hasOwnProperty(key)) {
      const siteObject = sites[key];
      if (siteObject.name) {
        const [month, year] = siteObject.name.split('-');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthName = monthNames[parseInt(month, 10) - 1];
        siteObject.name = `${monthName}-${year}`;
      }
      data3.push(siteObject); // Print the key (date)
    }
  }
  setDataFinal(data3);
  setExcelCityData(pmsReportChartData?.subjectChartData);
          } else if (pmsReportChartData?.subjectChartData && pmsReportChartData?.subjectChartData.ZonewisesubjectsEnrolled) {
            const keys = Object.keys(pmsReportChartData?.subjectChartData?.ZonewisesubjectsEnrolled);
            const datesSet = new Set();
  
            keys.forEach(key => {
              const keyDates = Object.keys(pmsReportChartData?.subjectChartData?.ZonewisesubjectsEnrolled[key]);
              keyDates.forEach(date => {
                datesSet.add(date);
              });
            });
            
            // Convert the Set back to an array
            const dates = Array.from(datesSet);
    
    
  const sites = {};
  
  dates.forEach((date) => {
    const dateObject = {};
  
    for (var i = 0; i < keys.length; i++) {
      const siteValue = pmsReportChartData?.subjectChartData?.ZonewisesubjectsEnrolled[keys[i]][date];
      if(siteValue!==undefined){
      dateObject[keys[i]] = siteValue;
      }
    }
  
    sites[date] = {
      name: date,
      ...dateObject
    };
  
    
  });
  
  for (const key in sites) {
    if (sites.hasOwnProperty(key)) {
      const siteObject = sites[key];
      if (siteObject.name) {
        const [month, year] = siteObject.name.split('-');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthName = monthNames[parseInt(month, 10) - 1];
        siteObject.name = `${monthName}-${year}`;
      }
      data3.push(siteObject);
    }
  }
  setDataFinal(data3)
  setExcelZoneData(pmsReportChartData?.subjectChartData);
          }else if(pmsReportChartData?.subjectChartData && pmsReportChartData?.subjectChartData.SitewisesubjectsEnrolled){
            const keys = Object.keys(pmsReportChartData?.subjectChartData?.SitewisesubjectsEnrolled);
            const datesSet = new Set();
  
            keys.forEach(key => {
              const keyDates = Object.keys(pmsReportChartData?.subjectChartData?.SitewisesubjectsEnrolled[key]);
              keyDates.forEach(date => {
                datesSet.add(date);
              });
            });
            
            // Convert the Set back to an array
            const dates = Array.from(datesSet);
    
    
  const sites = {};
  
  dates.forEach((date) => {
    const dateObject = {};
  
    for (var i = 0; i < keys.length; i++) {
      const siteValue = pmsReportChartData?.subjectChartData?.SitewisesubjectsEnrolled[keys[i]][date];
      if(siteValue!==undefined){
      dateObject[keys[i]] = siteValue;
      }
    }
  
    sites[date] = {
      name: date,
      ...dateObject
    };
  
    
  });
  
  for (const key in sites) {
    if (sites.hasOwnProperty(key)) {
      const siteObject = sites[key];
      if (siteObject.name) {
        const [month, year] = siteObject.name.split('-');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthName = monthNames[parseInt(month, 10) - 1];
        siteObject.name = `${monthName}-${year}`;
      }
      data3.push(siteObject); // Print the key (date)
    }
  }
  setDataFinal(data3)
  setExcelSiteData(pmsReportChartData?.subjectChartData)
          } 
          else {
            
          }

        },[pmsReportChartData])
    
      const lineKeys = dataFinal && dataFinal[0] ? Object.keys(dataFinal[0]).filter((key) => key !== 'name') : [];

      function getRandomColor() {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
      }
      const handleZoneClearSelection = () => {  
        setPersonName([]);
        setStatesByZone([]);
        setCitiesByState([]);
        setCityName([])
      };

      const handleStateClearSelection = () => { 
        setstateName([]);
        setCitiesByState([]);
      };
      

      const handleCityClearSelection = () => { 
        setCityName([]);
      };

      const [scrollPosition, setScrollPosition] = useState(0);

      const getRandomColorNew = () => {
        const getRandomValue = () => Math.floor(Math.random() * 256);
        
        const isTooLight = (r, g, b) => (r + g + b) / 3 > 200; // Adjust threshold as needed
      
        let color;
        do {
          const red = getRandomValue();
          const green = getRandomValue();
          const blue = getRandomValue();
      
          color = `rgb(${red}, ${green}, ${blue})`;
        } while (isTooLight(...color.match(/\d+/g).map(Number)));
      
        return color;
      };

      const scrollThreshold = 70;
      const backgroundColor = scrollPosition > scrollThreshold ? 'whitesmoke' : 'white';

      const [genderBool,setGenderBool]=useState(false);

      const[total_sum,setTotalSum]=useState(0);
      
      useEffect(() => {
        if(genderChart!==null && genderChart.length>0){
        let arr = Object.keys(genderChart);
        
        let sum = Object.values(genderChart).reduce((acc, entry) => acc + entry.value, 0);
        setTotalSum(sum)

        const allValuesAreZero = arr.every(key => genderChart[key]?.value === 0);
        if(allValuesAreZero){
          setGenderBool(true);
        }
        else{
          setGenderBool(false);
        }
      }
      }, [genderChart]);
     
      const handleZoneAllSelect = () => {
        setFecthLoader(true);
      
        if (personName?.length !== zone_options?.length) {
          const all = zone_options.map((option) => option.label);
          const selectedValues = zone_options.map((option) => option.value);
      
          if (selectedValues !== null) {
            axios
              .post(base_url + "states/get_states_by_zone", {
                zone_id: selectedValues,
              })
              .then((res) => {
                setStatesByZone(res.data.data);
      
                if (selectedValues !== null && selectedValues.length !== 0) {
                  setZonesForApi(selectedValues);
                  dispatch(getPmsReportsChartData(localStorage.study_id, selectedValues));
                }
      
                setPersonName(all);
                setFecthLoader(false); 
              })
              .catch((err) => {
                console.log(err);
                setFecthLoader(false); 
              });
          }
        }
      };
      

      const handleStateAllSelect = () => {
        setFecthLoader(true);
      
        const all = state_options.map((option) => option.label);
        const selectedValues = state_options.map((option) => option.value);
        setstateName(all);
      
        if (selectedValues !== null) {
          axios
            .post(base_url + "cities/get_cities_by_state_for_reports", {
              state_id: selectedValues,
            })
            .then((res) => {
              setCitiesByState(res.data.data);
      
              if (selectedValues !== null && selectedValues.length !== 0 && zones_for_api !== null && zones_for_api.length !== 0) {
                setStatesForApi(selectedValues);
                dispatch(getPmsReportsChartData(localStorage.study_id, zones_for_api, selectedValues));
              }
      
              setFecthLoader(false); 
            })
            .catch((err) => {
              console.log(err);
              setFecthLoader(false); 
            });
        }
      };
      

      const handleCityAllSelect = () => {
        setFecthLoader(true);
      
        const all = citiesByState.map((option) => option.label);
        const selectedValues = citiesByState.map((option) => option.value);
        setCityName(all);
      
        if (selectedValues !== null && selectedValues.length !== 0 && zones_for_api !== null && zones_for_api.length !== 0 && states_for_api !== null && states_for_api.length !== 0) {
          dispatch(getPmsReportsChartData(localStorage.study_id, zones_for_api, states_for_api, selectedValues));
          setTimeout(() => {
            setFecthLoader(false);
          }, 4000);
        }
      };

      const renderTooltip = (props) => {
        const { active, label, payload } = props;
        if (active) {
          const tooltipItem = dataFinal.find(item => item.name === label);
          return (
            <div className="custom-tooltip">
              <span className="label" style={{lineHeight:"-5px"}}>{`${label}`}</span>
              {payload?.map((entry, index) => (
                entry.value > 0 && 
                <span key={index} style={{ color: entry.color,lineHeight:"-5px" }}>
                  {`${entry.name}: ${entry.value}`}
                </span>
              ))}
            </div>
          );
        }
        return null;
      }

  return (
    <div>
    <NavigationBar title={"Reports"} rolecode={rolecode} setClearFilters={setClearFilters}/>
    <div className='main_body '>
      {loading ? <div className=''>
                      <img
                          className="atrium_loader"
                          src="/images/circle-effect-loading.gif"
                          alt="Loader"

                      />
                  </div> : <Container fluid className='py-2 '>
                    <Stack direction="horizontal" gap={2} className=" pb-2 add_subject_stack" style={{position:"sticky",zIndex:200,backgroundColor:backgroundColor}}>
                    <div>
                    <FormControl sx={{ width: 200 }}>
        
        <Select
        style={{height:"50px"}}
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          displayEmpty
          value={personName && personName}
          onChange={handleChangeZone}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <div>Select Zones</div>;
            }

            return selected.join(', ');
          }}
          MenuProps={MenuProps}
        >
         {zone_options.length>0?<>
            <div className='d-flex justify-content-center mt-1'>
            <button onClick={handleZoneAllSelect} style={{border:"0px",backgroundColor:"#98bad5",marginRight:"10px"}} >Select all</button>
            <button onClick={handleZoneClearSelection} style={{border:"0px",backgroundColor:"#D3D3D3"}} >Clear all</button>
          </div>
           <hr style={{marginBottom:"8px"}}/>
           </>:""
         }

          {zone_options.map((name) => (
            <MenuItem key={name.value} value={name.label}>
              <Checkbox checked={personName.indexOf(name.label) > -1} />
              <ListItemText primary={name.label} />
            </MenuItem>
          ))}
         

        
        </Select>
      </FormControl>               
    </div>
    <div>
                    <FormControl sx={{ width: 250 }}>
        
        <Select
         style={{height:"50px"}}
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          displayEmpty
          disabled = {state_options.length == 0 ?true : false}
          value={stateName}
          onChange={handleChangeState}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <div>Select states</div>;
            }

            return selected.join(', ');
          }}
          MenuProps={MenuProps}
        >
        {state_options.length>0?<>
          
            <div className='d-flex justify-content-center mt-1'>
            <button onClick={handleStateAllSelect} style={{border:"0px",backgroundColor:"#98bad5",marginRight:"10px"}} >Select all</button>
            <button onClick={handleStateClearSelection} style={{border:"0px",backgroundColor:"#D3D3D3"}} >Clear all</button>
          </div>
          <hr style={{marginBottom:"8px"}}/>
          </>:""}
          {state_options.map((name) => (
            <MenuItem key={name.value} value={name.label}>
              <Checkbox checked={stateName.indexOf(name.label) > -1} />
              <ListItemText primary={name.label} />
            </MenuItem>
          ))}

        </Select>
      </FormControl>
                   
                    
    </div>
    <div>
                    <FormControl sx={{ m: 1, width: 250 }}>
        
        <Select
         style={{height:"50px"}}
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          disabled = {citiesByState.length == 0 ?true : false}
          multiple
          displayEmpty
          value={cityName}
          onChange={handleChangeCity}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <div>Select Cities</div>;
            }

            return selected.join(', ');
          }}
          MenuProps={MenuProps}
        >
                    {citiesByState.length>0?<>  
         
            <div className='d-flex justify-content-center mt-1'>
            <button onClick={handleCityAllSelect} style={{border:"0px",backgroundColor:"#98bad5",marginRight:"10px"}} >Select all</button>
            <button onClick={handleCityClearSelection} style={{border:"0px",backgroundColor:"#D3D3D3"}} >Clear all</button>
          </div>
          <hr style={{marginBottom:"8px"}}/>
          </>:""}
          {citiesByState.map((name) => (
            <MenuItem key={name.value} value={name.label}>
              <Checkbox checked={cityName.indexOf(name.label) > -1} />
              <ListItemText primary={name.label} />
            </MenuItem>
          ))}

        </Select>
      </FormControl>
                   
                    
    </div>
                        <div style={{marginTop:"5px"}}>
                            <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                        </div>

                    </Stack>
 <div>
    <div className="row mb-3">
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px",zIndex:2}} >
      <div className="card-body">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Subjects Registered</h6>
        <div>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSubjects}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
      </div>
      <div className='subject-line-chart'>
<LineChart width={600} height={330} data={dataFinal} margin={{ top: 8, right: 20, left: 13, bottom: 25 }}>
  <CartesianGrid strokeDasharray="3 3" />
  <XAxis dataKey="name" padding={{ left: 30, right: 20 }} tickLine={false} axisLine={false} fontSize={10}>
    <Label value="▮ Month wise subjects registered" position="bottom" offset={7} style={{ fill: 'black', fontSize:"small" }} />
  </XAxis>
  <YAxis tickLine={false} axisLine={false} fontSize={12}>
    <Label value="Number of subjects" position="left" angle={-90} className="y-axis-label" offset={3} style={{ fill: 'black', fontSize:"small" }} dx={5} fontSize={14}/>
  </YAxis>
  <Tooltip content={renderTooltip} wrapperStyle={{pointerEvents: 'auto'}} contentStyle={{maxWidth:"400px"}} offset={-20}/>
  {/* <Legend verticalAlign="top" align="right" height={36}  wrapperStyle={{ fontSize: '10px' }}  /> */}
  {lineKeys.map((key, index) => (
    // dataFinal.map((dataObject, index) => (

        <Line
        key={`${key}`}
          type="monotone"
          dataKey={key}
          stroke={getRandomColorNew()} // Customize the stroke color as needed
          activeDot={{ r: 8 }}
        />
        // ))
      ))}
</LineChart>
</div>
      </div>
    </div>
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
      <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Serious Adverse Events</h6>
        <div>
        <select value={saeDoseSelect && saeDoseSelect} onChange={handleOptionSelectSaeDose}  style={{ width: "auto",marginRight:"5px" }} >
                                {listOfSaeDoes?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSeriousAdverse}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
      </svg>
        </button>
        </div>
        </div>
        {chartData.length>0 ?
        <div id="chart" style={{marginTop:"45px",marginLeft:"40px"}}>
      <ReactApexChart options={chartOptions} series={chartData} type="pie" width={430} 
      />
      
      <div style={{textAlign:"center",paddingTop:"80px"}}>
        <span style={{ fontSize:"small"}}>▮ Dose wise serious adverse events</span>
      </div>

    </div>:""}
    { chartData.length===0 ?
    <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
      No serious adverse events found
    </div>:""}
    
      </div>
    </div>
  </div>
  
</div>
<div className="row mb-3">
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Adverse Events</h6>
        <div>
        <select value={eventDoseSelect} onChange={handleOptionSelectEventDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfEvents?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelAdverse}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div>
        {
          eventsChart && eventsChart.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={eventsChart && eventsChart}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnter(params.index, params.coordinate)}
  
      >
        <Label value="▮ Adverse Events"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No of Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No adverse events found
          </div>
        }
        {tooltip !== null && (
  <div
  onMouseLeave={handleMouseLeave}
    style={{
      position: 'absolute',
      left: tooltip.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {eventsChart[tooltip.index].name}
  </div>
)}

      
       </div>
       
      </div>
    </div>
  </div>
 
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Target vs Actual</h6>
        <div>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelDose}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
      </svg>
        </button>
        </div>
        </div>
        {doseChart.length>0?
        <div className='d-flex' style={{alignItems:"center"}} >
    <RadialBarChart 
        width={300} 
        height={300} 
        innerRadius="30%" 
        outerRadius="90%" 
        data={doseChart && doseChart} 
        barSize={8}
        cx={120}
        cy={130}
        
      >

  <RadialBar minAngle={15} label={false} background clockWise={true} dataKey='subjects'   />
  {/* <Legend iconSize={10} width={90} height={80} layout='vertical' verticalAlign='middle' align="right" /> */}
 
  <Tooltip 
    labelFormatter={(index) => `Dose ${index+1}`}
    />
  
  
</RadialBarChart>

<div >
  <div style={{color:"red", marginBottom:"10px"}}>Target: {target}</div>
        {doseChart.map((entry, index) => (
          <div key={index} className="legend-item">
            <span className="legend-color" ></span>
            <span className="legend-label" style={{ color: colors[index] }}>{entry.name}&nbsp;&nbsp;&nbsp;</span>
            <span className="legend-value" style={{ color: colors[index] }}>
            {entry.subjects}
              </span>
          </div>
        ))}
        </div>
        </div>: 
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>No doses found</div>}

    {doseChart.length>0?
    <div style={{textAlign:"center"}}>
    <span style={{ fontSize:"small"}}>▮ Dose wise subjects registered</span>
    </div>:""}
      </div>      
    </div>   
  </div>
  
</div>
<div className="row mb-2">
<div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Subjects Age wise</h6>
        <div>
        <select value={ageDose} onChange={handleOptionSelectAgeDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfAgeDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelAge}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          ageChart && ageChart.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={ageChart && ageChart}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnter2(params.index, params.coordinate)}
      >
        <Label value="▮ Age group"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of subjects' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Subjects found
          </div>
        }
        {tooltip_age !== null && (
  <div
  onMouseLeave={handleMouseLeave2}
    style={{
      position: 'absolute',
      left: tooltip_age.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {ageChart[tooltip_age?.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div>   
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Subjects Gender Wise</h6>
        <div>
        <select value={genderDose} onChange={handleOptionSelectGenderDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfGenderDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelGender}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div>
        {
          genderChart && genderChart.length>0 ?
          <PieChart width={300} height={300} >
          <Pie
            data={genderChart}
            dataKey="value"
            nameKey="name"
            // cx="50%"
            // cy="50%"
            cx={120}
            cy={130}
            innerRadius={82}
            outerRadius={100}
            paddingAngle={2}
          >
            {genderChart.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: genderBool ? 20 : -100 }}
            formatter={(value, entry) => (
              <span>
                <span>{`${entry.payload.name}`}</span>
                <span style={{ color: "black" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
       
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        genderChart && genderChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of subjects by gender</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>
  </div>
 
 
  
</div>

{/* ======================================================zone and state wise subjec counts graph ========================= */}
<div className="row mb-2">
<div className="col-sm-6 d-flex ">
<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Zone Wise Subject Count</h6>
        <div>
        <select value={zoneWiseDose} onChange={handleOptionSelectZoneWiseDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfZoneWiseDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelZoneWiseSubjectCount}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          zoneWiseChart && zoneWiseChart.length>0 ?
          <PieChart width={300} height={300} style={{marginLeft:"100px"}} >
            <Pie
              data={zoneWiseChart}
              dataKey="value"
              nameKey="name"
              // cx="50%"
              // cy="50%"
              cx={120}
              cy={130}
              fontSize={10}
              innerRadius={0}
              outerRadius={100}
              paddingAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {zoneWiseChart.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -100, maxHeight:200, maxWidth: 220, overflow: 'auto' }}
            formatter={(value, entry) => (
              <span>
                <span>{`${entry.payload.name}`}</span>
                <span style={{ color: "black" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
       
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        zoneWiseChart && zoneWiseChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of subjects by zone</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>   
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>State Wise Subject Count</h6>
        <div>
        <select value={stateWiseDose} onChange={handleOptionSelectStateWiseDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfStateWiseDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelStateWiseSubjectCount}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          stateWiseChart && stateWiseChart.length>0 ?
          <div style={{ }}>
          <PieChart width={300} height={300} >
          <Pie
            data={stateWiseChart}
            dataKey="value"
            nameKey="name"
            // cx="50%"
            // cy="50%"
            cx={120}
            cy={130}
            innerRadius={0}
            outerRadius={100}
            paddingAngle={0}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            
            {stateWiseChart.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
            
          />
          
          
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -160, maxHeight:200, maxWidth: 220, overflow: 'auto'}}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
          </PieChart>
        
        </div>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        stateWiseChart && stateWiseChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of subjects by State</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>
  </div>
 
 
  
</div>
{/* ======================================================SOC and PT Bar Graphs ========================= */}
<div className="row mb-2">
<div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Overall Adverse Events with SOC</h6>
        <div>
        <select value={socDose} onChange={handleOptionSelectSocDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfSocDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSoc}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          socChart && socChart.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={socChart && socChart}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black",
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterSoc(params.index, params.coordinate)}
      >
        <Label value="▮ SOC Name"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
        {tooltipSoc !== null && (
  <div
  onMouseLeave={handleMouseLeaveSoc}

    style={{
      position: 'absolute',
      left: tooltipSoc.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {socChart[tooltipSoc.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div>   
  </div>
  {/* ========================PT Graph */}
  <div className="col-sm-6 d-flex ">
  <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Overall Adverse Events with PT</h6>
        <div>
        <select value={ptDose} onChange={handleOptionSelectPtDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfPtDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelPt}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          ptChart && ptChart.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={ptChart && ptChart}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterPt(params.index, params.coordinate)}
      >
        <Label value="▮ PT Name"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
        {tooltipPt !== null && (
  <div
  onMouseLeave={handleMouseLeavePt}

    style={{
      position: 'absolute',
      left: tooltipPt.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {ptChart[tooltipPt.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div> 
  </div>
 
 
  
</div>

{/* ======================================================SAE SOC AND PT GRAPHS ================================ */}
<div className="row mb-2">
<div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Overall Serious Adverse Events with SOC</h6>
        <div>
        <select value={saeSocDose} onChange={handleOptionSelectSaeSocDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfSaeSocDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSaeSoc}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          saeSocChart && saeSocChart.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={saeSocChart && saeSocChart}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterSaeSoc(params.index, params.coordinate)}
  // onMouseLeave={handleMouseLeaveSaeSoc}
      >
        <Label value="▮ SAE SOC Name"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Serious Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
        {tooltipSaeSoc !== null && (
          <div
          onMouseLeave={handleMouseLeaveSaeSoc}
            style={{
              position: 'absolute',
              left: tooltipSaeSoc.coordinate - 45,
              bottom: 45,
              overflowY: 'auto',
              // color:"#83a6ed",
              backgroundColor:"#f1f1f1",
              width:130,
              maxHeight:"40px",
              textAlign:"center",
              fontSize:"12px",
              fontWeight:"bold"
              
            }}
          >
            {saeSocChart[tooltipSaeSoc.index].name}
          </div>
)}

      
       </div>
      </div>      
    </div>   
  </div>
  {/* ========================PT Graph */}
  <div className="col-sm-6 d-flex ">
  <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Overall Serious Adverse Events with PT</h6>
        <div>
        <select value={saePtDose} onChange={handleOptionSelectSaePtDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfSaePtDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSaePt}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          saePtChart && saePtChart.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={saePtChart && saePtChart}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterSaePt(params.index, params.coordinate)}

      >
        <Label value="▮ SAE PT Name"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Serious Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip/>
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
        {tooltipSaePt !== null && (
  <div
  onMouseLeave={handleMouseLeaveSaePt}

    style={{
      position: 'absolute',
      left: tooltipSaePt.coordinate - 45,
      bottom: 60,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {saePtChart[tooltipSaePt.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div> 
  </div>
 
 
  
</div>


{/* ====================================Over all AE AGE AND GENDER ============================================== */}

<div className="row mb-2">
<div className="col-sm-6 d-flex ">

<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Overall Adverse Events Age</h6>
        <div>
        <select value={ageDoseAe} onChange={handleOptionSelectAgeDoseAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfAgeDosesAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelAgeAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          ageChartAe && ageChartAe.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={ageChartAe && ageChartAe}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterAeAge(params.index, params.coordinate)}
      >
        <Label value="▮ Adverse Events Age group"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Subjects found
          </div>
        }
        {tooltip_age_ae !== null && (
  <div
  onMouseLeave={handleMouseLeaveAeAge}

    style={{
      position: 'absolute',
      left: tooltip_age_ae.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {ageChartAe[tooltip_age_ae?.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div> 
      
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Overall Adverse Events Gender</h6>
        <div>
        <select value={genderDoseAe} onChange={handleOptionSelectGenderDoseAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfGenderDosesAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelAeGender}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div>
        {
          genderChartAe && genderChartAe.length>0 ?
          <div style={{ }}>
          <PieChart width={300} height={300} >
          <Pie
            data={genderChartAe}
            dataKey="value"
            nameKey="name"
            // cx="50%"
            // cy="50%"
            cx={120}
            cy={130}
            innerRadius={0}
            outerRadius={100}
            paddingAngle={0}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            
            {genderChartAe.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
            
          />
          
          
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -160, maxHeight:200, maxWidth: 220, overflow: 'auto'}}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
          </PieChart>
        
        </div>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        genderChartAe && genderChartAe.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events by Gender</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>
  </div>
 
 
  
</div>

{/* =============================================== */}

{/* ============================ Over All SAE AGE AND GENDER =================== */}
<div className="row mb-2">
<div className="col-sm-6 d-flex ">

<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Overall Serious Adverse Events Age</h6>
        <div>
        <select value={ageDoseSae} onChange={handleOptionSelectAgeDoseSae}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfAgeDosesSae?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSaeAge}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          ageChartSae && ageChartSae.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={ageChartSae && ageChartSae}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterSaeAge(params.index, params.coordinate)}
      >
        <Label value="▮ Serious Adverse Events Age group"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Serious Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Subjects found
          </div>
        }
        {tooltip_age_sae !== null && (
  <div
  onMouseLeave={handleMouseLeaveSaeAge}

    style={{
      position: 'absolute',
      left: tooltip_age_sae.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {ageChartSae[tooltip_age_sae?.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div> 
      
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Overall Serious Adverse Events Gender</h6>
        <div>
        <select value={genderDoseSae} onChange={handleOptionSelectGenderDoseSae}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfGenderDosesSae?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelSaeGender}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div>
        {
          genderChartSae && genderChartSae?.length>0 ?
          <div style={{ }}>
          <PieChart width={300} height={300} >
          <Pie
            data={genderChartSae}
            dataKey="value"
            nameKey="name"
            // cx="50%"
            // cy="50%"
            cx={120}
            cy={130}
            innerRadius={0}
            outerRadius={100}
            paddingAngle={0}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            
            {genderChartAe.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
            
          />
          
          
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -160, maxHeight:200, maxWidth: 220, overflow: 'auto'}}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
          </PieChart>
        
        </div>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        genderChartSae && genderChartSae?.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Serious Adverse Events by Gender</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>
  </div>
 
 
  
</div>

{/* ==================================== */}

{/* ===============================AESI AGE AND GENDER =================== */}

<div className="row mb-2">
<div className="col-sm-6 d-flex ">

<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body">
        <div className='d-flex flex-row justify-content-between'>
        <h6 className="card-text" style={{fontWeight:600}}>Adverse Events Special Interest Age</h6>
        <div>
        <select value={ageDoseAesi} onChange={handleOptionSelectAgeDoseAesi}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfAgeDosesAesi?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelAgeAesi}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
        <div>
        {
          ageChartAesi && ageChartAesi.length>0 ?
          <BarChart
          width={600}
          height={330}
          data={ageChartAesi && ageChartAesi}
          margin={{
            top: 7,
            right: 25,
            left: 5,
            bottom: 50
          }}
         
        >
          
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tickLine={false} axisLine={false} angle={-50} dy={10} dx={-17} interval={0}  tick={{
        fontSize: 10,fill:"black"
      }}
      tickFormatter={(value) =>
        value.length > 8 ? value.substring(0, 9) + "..." : value
      }
      onMouseEnter={(params) => handleMouseEnterAesiAge(params.index, params.coordinate)}
      >
        <Label value="▮ Adverse Events Special Intrest Age group"  position="bottom" offset={34} style={{ fill: 'black', fontSize:"small" }}/>
      </XAxis>
          <YAxis tickLine={false} axisLine={false} ><Label value= 'No.of Adverse Events' position= 'left' angle={-90} className="y-axis-label" offset={0} style={{ fill: 'black', fontSize:"small" }} dy={20} dx={5}/></YAxis>
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="count" fill="#83a6ed"  barSize={8} />
        </BarChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Subjects found
          </div>
        }
        {tooltip_age_aesi !== null && (
  <div
  onMouseLeave={handleMouseLeaveAesiAge}
    style={{
      position: 'absolute',
      left: tooltip_age_aesi.coordinate - 45,
      bottom: 40,
      overflowY: 'auto',
      // color:"#83a6ed",
      backgroundColor:"#f1f1f1",
      width:130,
      maxHeight:"40px",
      textAlign:"center",
      fontSize:"12px",
      fontWeight:"bold"
      
    }}
  >
    {ageChartAesi[tooltip_age_aesi?.index]?.name}
  </div>
)}

      
       </div>
      </div>      
    </div> 
      
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Adverse Events Special Interest Gender</h6>
        <div>
        <select value={genderDoseAesi} onChange={handleOptionSelectGenderDoseAesi}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfGenderDosesAesi?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelAesiGender}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          genderChartAesi && genderChartAesi?.length>0 ?
          <div style={{ }}>
          <PieChart width={300} height={300} >
          <Pie
            data={genderChartAesi}
            dataKey="value"
            nameKey="name"
            // cx="50%"
            // cy="50%"
            cx={120}
            cy={130}
            innerRadius={0}
            outerRadius={100}
            paddingAngle={0}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            
            {genderChartAe.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
            
          />
          
          
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -160, maxHeight:200, maxWidth: 220, overflow: 'auto'}}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
          </PieChart>
        
        </div>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        genderChartAesi && genderChartAesi?.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events Special Intrest by Gender</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>
  </div>
 
 
  
</div>


{/* ================================ */}

{/* ===========================Action taken for AE and outcomes of AE */}
<div className="row mb-2">
<div className="col-sm-6 d-flex ">
<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Action Taken for Adverse Events</h6>
        <div>
        <select value={actionTakenAeDose} onChange={handleOptionSelectActionTakenAeDose}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfActionTakenAeDoses?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelActionTakenAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          actionTakenAeChart && actionTakenAeChart.length>0 ?
          <PieChart width={300} height={300} style={{marginLeft:"50px"}} >
            <Pie
              data={actionTakenAeChart}
              dataKey="value"
              nameKey="name"
              // cx="50%"
              // cy="50%"
              cx={120}
              cy={130}
              innerRadius={0}
              outerRadius={100}
              paddingAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {actionTakenAeChart.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -170, maxHeight:200, maxWidth: 220, overflow: 'auto' }}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
       
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No gender found
          </div>
        }
       {
        actionTakenAeChart && actionTakenAeChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>   
  </div>
  <div className="col-sm-6 d-flex ">
    <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Outcomes Of Adverse Events</h6>
        <div>
        <select value={outcomesAeDose} onChange={handleOptionSelectOutcomesAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfOutcomesAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelOutcomesAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div>
        {
          outcomesAeChart && outcomesAeChart.length>0 ?
          <div style={{ }}>
          <PieChart width={300} height={300} >
          <Pie
            data={outcomesAeChart}
            dataKey="value"
            nameKey="name"
            // cx="50%"
            // cy="50%"
            cx={120}
            cy={130}
            innerRadius={0}
            outerRadius={100}
            paddingAngle={0}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            
            {outcomesAeChart.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
            
          />
          
          
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -160, maxHeight:200, maxWidth: 220, overflow: 'auto'}}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
          </PieChart>
        
        </div>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
       {
        outcomesAeChart && outcomesAeChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>
  </div>
</div>

{/* =================================================== */}


{/* ================================= Treatment Received for AE ================ */}

<div className="row mb-2">
<div className="col-sm-6 d-flex ">
<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Treatments Received for Adverse Events</h6>
        <div>
        <select value={treatmentsAeDose} onChange={handleOptionSelectTreatmentAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfTreatmentsAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelTreatmentsAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          treatmentsAeChart && treatmentsAeChart.length>0 ?
          <PieChart width={300} height={300} style={{marginLeft:"50px"}} >
            <Pie
              data={treatmentsAeChart}
              dataKey="value"
              nameKey="name"
              // cx="50%"
              // cy="50%"
              cx={120}
              cy={130}
              innerRadius={0}
              outerRadius={100}
              paddingAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {treatmentsAeChart.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -170, maxHeight:200, maxWidth: 220, overflow: 'auto' }}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black",fontSize:"small"}}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
       
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
       {
        treatmentsAeChart && treatmentsAeChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>   
  </div>
  <div className="col-sm-6 d-flex ">
  <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Adverse Events With Comorbidities</h6>
        <div>
        <select value={comorbiditiesAeDose} onChange={handleOptionSelectComorbiditiesAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfComorbiditiesAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelComorbiditiesAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          comorbiditiesAeChart && comorbiditiesAeChart.length>0 ?
          <PieChart width={300} height={300} style={{marginLeft:"50px"}} >
            <Pie
              data={comorbiditiesAeChart}
              dataKey="value"
              nameKey="name"
              // cx="50%"
              // cy="50%"
              cx={120}
              cy={130}
              innerRadius={0}
              outerRadius={100}
              paddingAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {comorbiditiesAeChart.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -220, maxHeight:200, maxWidth: 400, overflow: 'auto' }}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
       
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
       {
        comorbiditiesAeChart && comorbiditiesAeChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div> 
    
  </div>
</div>

{/* =========================================================== */}

{/* ======================================= last 2 charts ========================= */}
<div className="row mb-2">
<div className="col-sm-6 d-flex ">
<div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Adverse Events Classification</h6>
        <div>
        <select value={classificationAeDose} onChange={handleOptionSelectClassificationAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfClassificationAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelClassificationAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          classificationAeChart && classificationAeChart.length>0 ?
          <PieChart width={300} height={300} style={{marginLeft:"50px"}} >
            <Pie
              data={classificationAeChart}
              dataKey="value"
              nameKey="name"
              // cx="50%"
              // cy="50%"
              cx={120}
              cy={130}
              innerRadius={0}
              outerRadius={100}
              paddingAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {classificationAeChart.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -170, maxHeight:200, maxWidth: 220, overflow: 'auto' }}
            formatter={(value, entry) => (
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}>
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
            )}
          />
       
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Classifications found
          </div>
        }
       {
        classificationAeChart && classificationAeChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Classifications</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div>   
  </div>
  <div className="col-sm-6 d-flex ">
  <div className="card w-100" style={{height:"400px"}}>
      <div className="card-body bar-class">
      <div className='d-flex flex-row justify-content-between'>
      <h6 className="card-text" style={{fontWeight:600}}>Adverse Events Intervals</h6>
        <div>
        <select value={intervalsAeDose} onChange={handleOptionSelectIntervalsAe}  style={{ width: "auto",marginRight:"10px"}}>                        
                                {listOfIntervalsAe?.map((option) => (
                                <option key={option} value={option} title={option}>
                                    {option}
                                </option>
                                ))}
                            </select>
        <button style={{backgroundColor:"green",color:"white"}} onClick={exportExcelIntervalsAe}>Download
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16" style={{marginLeft:"5px"}}>
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>
        </button>
        </div>
        </div>
       <div style={{display:"flex", flexDirection:"column"}}>
        {
          intervalsAeChart && intervalsAeChart.length>0 ?
          <PieChart width={300} height={300} style={{marginLeft:"50px"}} >
            <Pie
              data={intervalsAeChart}
              dataKey="value"
              nameKey="name"
              // cx="50%"
              // cy="50%"
              cx={120}
              cy={130}
              innerRadius={0}
              outerRadius={100}
              paddingAngle={0}
              labelLine={false}
              label={renderCustomizedLabel}
            >
              {intervalsAeChart.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          <Tooltip
            formatter={(value) =>
              `${value}`
            }
          />
          <Legend
            align="right"
            verticalAlign="middle"
            layout="vertical"
            iconSize={20}
            wrapperStyle={{ right: -240, maxHeight:200, maxWidth: 400, overflow: 'auto' }}
            formatter={(value, entry) => (
              
              <span>
                <span style={{fontSize:"small"}}>{`${entry.payload.name}`}</span>
                <span style={{ color: "black", fontSize:"small" }}> - 
          {` ${entry.payload.value ? entry.payload.value :0}`}</span>
              </span>
              
            )}
          />
        </PieChart>:
        <div className='d-flex flex-row justify-content-center' style={{paddingTop:"150px"}}>
          No Events found
          </div>
        }
       {
        intervalsAeChart && intervalsAeChart.length>0 ?
        <div style={{textAlign:"center",paddingTop:"5px"}}>
        <span style={{ fontSize:"small"}}>▮ No.of Adverse Events</span>
        </div>:""
       }

      
       </div>
       
      </div>
    </div> 
    
  </div>
</div>


{/* ============================================= */}

</div>



                </Container>
                  
                  }
                {fetchLoader && <Loader />}
                </div>
    </div>
  )
}

export default PMSAllReports
